export const FormFieldPropertyObjectTypes = {
  CONTACT: 'CONTACT',
  COMPANY: 'COMPANY',
  TICKET: 'TICKET',
  UNKNOWN: 'UNKNOWN'
};
export const PropertyObjectTypes = Object.assign({}, FormFieldPropertyObjectTypes, {
  DEAL: 'DEAL',
  SHIPMENT: 'SHIPMENT',
  CUSTOM: 'CUSTOM',
  FEEDBACK_SUBMISSION: 'FEEDBACK_SUBMISSION',
  FEEDBACK: 'FEEDBACK',
  PRODUCT: 'PRODUCT',
  MARKETING_EVENT: 'MARKETING_EVENT'
});
export const FormFieldPropertyObjectTypesIds = {
  [PropertyObjectTypes.UNKNOWN]: '0-0',
  [PropertyObjectTypes.CONTACT]: '0-1',
  [PropertyObjectTypes.TICKET]: '0-5',
  [PropertyObjectTypes.COMPANY]: '0-2'
};
export const PropertyObjectTypesIds = Object.assign({}, FormFieldPropertyObjectTypesIds, {
  [PropertyObjectTypes.DEAL]: '0-3',
  [PropertyObjectTypes.SHIPMENT]: '0-x',
  [PropertyObjectTypes.PRODUCT]: '0-7',
  [PropertyObjectTypes.CUSTOM]: '0-x',
  [PropertyObjectTypes.FEEDBACK_SUBMISSION]: '0-1',
  [PropertyObjectTypes.FEEDBACK]: '0-19',
  [PropertyObjectTypes.MARKETING_EVENT]: '0-54'
});